import clsx from 'clsx';
import { ReactNode } from 'react';

type Props = {
  size?: number;
  className?: string;
  children: ReactNode;
  onClick?: VoidFunction;
};

const BaseButton = ({ size = 32, className, children, onClick }: Props) => {
  return (
    <button
      onClick={onClick}
      className={clsx(
        'flex justify-center items-center',
        'border border-gray-600 rounded-lg cursor-pointer',
        className
      )}
      style={{ width: size, height: size }}
    >
      {children}
    </button>
  );
};

export default BaseButton;
